const $ = (selector, parent = document) => parent.querySelector(selector);
const $$ = (selector, parent = document) => parent.querySelectorAll(selector);

const imageSwapper = $(".page-header-home .image-swapper");

if (imageSwapper) {
  const items = $$("li", imageSwapper);
  let currentItem = 0;

  function swapImage() {
    items[currentItem].classList.remove("active");
    currentItem = (currentItem + 1) % items.length;
    items[currentItem].classList.add("active");
  }

  setInterval(swapImage, 5000);
}